module.exports = __webpack_public_path__ + "static/media/app-store-nl.c5a46154.svg";